export class IdentityModel {
  constructor(
    public id:string,
    public status:string,
    public externalId:string,
    public registrationTime:Date,
    public displayName:string,
    public firstName:string,
    public lastName:string,
    public emailAddress:string,
    public phoneNumber:string,
    public upn:string,
    public integrationExternalId:string,
    public username:string,
    public language:string,
    public customPhoneNumber:string,
    public error: string
  ) {}
}

export class UpdateIdentityRequest {
    constructor(
      public language: string
    ) {}
}
